import React, { useState } from "react";
import "../../styles/Contact.css";

export default function ContactSection() {
    const [form, setForm] = useState({
        name: "", email: "", phone: "", subject: "", product: "", message: ""
    });

    const [status, setStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isEmailValid, setIsEmailValid] = useState(false);

    const handleChange = (e) => {
        if (isSubmitting) return;
        const { name, value } = e.target;
        setForm((prev) => ({ ...prev, [name]: value }));

        if (name === "email") {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            setIsEmailValid(emailRegex.test(value));
        }
    };

    const isFormValid =
        form.name.trim() &&
        form.email.trim() &&
        form.phone.trim() &&
        form.message.trim() &&
        isEmailValid;

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!isFormValid || isSubmitting) return;

        setIsSubmitting(true);
        setStatus("Please Wait...");

        try {
            const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/send-email`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(form),
            });
            const data = await res.json();

            setStatus(data.message);

            if (res.status === 200) {
                setForm({ name: "", email: "", phone: "", subject: "", product: "", message: "" });
                setIsEmailValid(false);
            }
        } catch (error) {
            setStatus("Something went wrong. Please try again.");
        }

        setTimeout(() => setStatus(""), 10000);
        setIsSubmitting(false);
    };

    return (
        <section id="contact" className="contact-section">
            <video className="contact-video" autoPlay muted loop playsInline>
                <source src="/ContactUs.mp4" type="video/mp4" />
                Your browser does not support the video tag.
            </video>

            <div className="contact-bg"></div>

            <div className="contact-container">
                <h5 className="contact-tagline">CONTACT US</h5>
                <h2 className="contact-heading">Have Questions?</h2>
                <h2 className="contact-heading">Get In Touch!</h2>

                <form onSubmit={handleSubmit}>
                    <div className="row">
                        <div className="input-group">
                            <input
                                type="text"
                                name="name"
                                placeholder="Your Name *"
                                value={form.name}
                                required
                                onChange={handleChange}
                                disabled={isSubmitting}
                            />
                        </div>

                        <div className="input-group">
                            <input
                                type="email"
                                name="email"
                                placeholder="Your Email *"
                                value={form.email}
                                required
                                onChange={handleChange}
                                disabled={isSubmitting}
                            />
                            {form.email && !isEmailValid && (
                                <div className="error-text">Please enter a valid email address.</div>
                            )}
                        </div>
                    </div>

                    <div className="row">
                        <input
                            type="tel"
                            name="phone"
                            placeholder="Phone *"
                            value={form.phone}
                            required
                            onChange={handleChange}
                            disabled={isSubmitting}
                        />
                        <input
                            type="text"
                            name="subject"
                            placeholder="Subject (Optional)"
                            value={form.subject}
                            onChange={handleChange}
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="row">
                        <input
                            type="text"
                            name="product"
                            placeholder="Product Info (Optional)"
                            value={form.product}
                            onChange={handleChange}
                            disabled={isSubmitting}
                        />
                    </div>

                    <div className="row">
                        <textarea
                            name="message"
                            placeholder="Your Message *"
                            value={form.message}
                            required
                            onChange={handleChange}
                            disabled={isSubmitting}
                        />
                    </div>

                    <button type="submit" disabled={!isFormValid || isSubmitting}>
                        {isSubmitting ? "Sending..." : "Send Message"}
                    </button>
                </form>

                {status && (
                    <p
                        className={`status-message ${status === "Please Wait..."
                                ? "status-waiting"
                                : status.toLowerCase().includes("wrong")
                                    ? "status-error"
                                    : "status-success"
                            }`}
                    >
                        {status}
                    </p>
                )}

                <p className="privacy-note">
                    By submitting this form, you consent to the collection and use of your information for the purpose of responding to your inquiry, in accordance with our privacy practices.
                </p>
            </div>
        </section >
    );
}
